import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, ResolveFn } from '@angular/router';
import { catchError, of, tap } from 'rxjs';
import { SharedService } from '../services/shared.service';
import { DashboardService } from '../api/services/dashboard.service';


export const RoleResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {

  const sharedService = inject(SharedService);
  const router = inject(Router);
  const dashboardService = inject(DashboardService);
  let role = sharedService.userRole;

  if (role !== undefined) {
    return role;
  }

  return dashboardService.getRole().pipe(
    tap(role => {
      sharedService.setRoleUser(role);
      console.log("Resolver", role);
      return of(true);
    }),
    catchError((e) => {
      sharedService.goToNotAuthorizedPage('role.resolver.ts - getRole().error');
      return of(e);
    }),
  )
}
